import RefWidget from './ref'
import { UsersWidget } from './users'

export default () => {
  return {
    ref: RefWidget,
    users: UsersWidget,
  }
}
